/** client/src/hooks/useFeedPreview.js */

import { useEffect, useState } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export default function useFeedPreview(docId) {
  const [items, setItems] = useState(null);
  const [meta, setMeta] = useState(null);

  useEffect(() => {
    function cleanDescription(rawHtml = '') {
      const tmp = document.createElement('div');
      tmp.innerHTML = rawHtml;

      // Remove all <img> tags
      tmp.querySelectorAll('img').forEach(img => img.remove());

      // Remove plain URLs from text (e.g., "http://example.com")
      const text = tmp.textContent || '';
      return text.replace(/https?:\/\/[^\s]+/g, '').trim();
    }

    const parseFeed = async () => {
      if (docId) {
        try {
          const res = await axios.get(`${API_URL}/api/documents/${docId}/view`, {
            withCredentials: true,
            responseType: 'text',
          });

          const text = res.data;
          const parser = new DOMParser();
          const xmlDoc = parser.parseFromString(text, 'application/xml');

          const isRSS = xmlDoc.querySelector('rss');
          const isAtom = xmlDoc.querySelector('feed');

          let entries = [];
          let feedMeta = { title: '' };

          if (isRSS) {
            const channel = xmlDoc.querySelector('channel');
            if (channel) {
              [...channel.children].forEach((el) => {
                if (el.tagName.toLowerCase() !== 'item') {
                  feedMeta[el.tagName.toLowerCase()] = el.textContent.trim();
                }
              });
            }

            entries = [...xmlDoc.querySelectorAll('item')].map(el => ({
              title: el.querySelector('title')?.textContent || '',
              link: el.querySelector('link')?.textContent || '',
              pubDate: el.querySelector('pubDate')?.textContent || '',
              description: cleanDescription(el.querySelector('description')?.textContent || '')
            }));
          } else if (isAtom) {
            const feedEl = xmlDoc.querySelector('feed');

            // Collect all child elements (excluding <entry>)
            if (feedEl) {
              [...feedEl.children].forEach((el) => {
                if (el.tagName.toLowerCase() !== 'entry') {
                  // Use attribute if <link>, otherwise use text content
                  const value = el.tagName.toLowerCase() === 'link'
                    ? el.getAttribute('href')
                    : el.textContent.trim();
                  feedMeta[el.tagName.toLowerCase()] = value;
                }
              });
            }

            entries = [...xmlDoc.querySelectorAll('entry')].map(el => ({
              title: el.querySelector('title')?.textContent || '',
              link: el.querySelector('link')?.getAttribute('href') || '',
              pubDate: el.querySelector('updated')?.textContent || '',
              description: cleanDescription(el.querySelector('summary')?.textContent || el.querySelector('content')?.textContent || '')
            }));
          }

          setItems(entries.slice(0, 15));
          setMeta(feedMeta);
        } catch (err) {
          console.error('Feed parse error:', err);
          setItems([]);
          setMeta(null);
        }
      }
    };

    parseFeed();
  }, [docId]);

  return { items, meta };
}